import * as React from "react";
import Image from "next/image";
import { Box, Typography, Stack } from "@mui/material";
import { useFiltersStore } from "@/store/useFilterStore";

type StatBoardProps = {
  title: string;
  yAxisUnit?: "AOV" | string;
  data?: {
    value?: string | number;
    difference?: string | number;
  };
  className ?: string;
};

const StatBoard: React.FC<StatBoardProps> = (props) => {
  const rawValue = Number(props.data?.value ?? 0);
  const rawDiff = Number(props.data?.difference ?? rawValue);
  const actualDataValue = Math.round(rawValue);
  const trendValue = Math.round(Math.abs(rawDiff));
  // For most metrics, higher is better; for "RTO %" lower is better.
  const positiveIsGood = props.title !== "RTO %";
  let isIncreasing = rawDiff > 0;
  if (!positiveIsGood) {
    isIncreasing = !isIncreasing;
  }

  const arrowStyle =
    props.title === "RTO %"
    ? { transform: isIncreasing ? "rotate(90deg)" : "rotate(-90deg)" }
    : {};

  return (
    <Box
      sx={{
        // width: "300px",
        borderRadius: 1,
        bgcolor: "transparent",
        overflow: "hidden",
         border: "0.85px solid #3636364D",
        background:"#161616",
      }}
      className={props.className}
    >
      <Box sx={{ p: 2, pb: 1 }}>
        <Typography variant="subtitle1" sx={{ color: "#fff", fontWeight: 500 }}>
          {props.title}
        </Typography>
      </Box>

      <Box sx={{ px: 2, pb: 2 }}>
        <Stack direction="row" justifyContent="space-between" sx={{ pt: 3 }}>
          {/* Left side */}
          <Stack spacing={1}>
            <Typography
              component="p"
              sx={{ fontSize: 28, lineHeight: "44px", fontWeight: 600, color: "#fff" }}
            >
              {props.title == "AOV" && "₹ "}
              {actualDataValue}
              {props.title != "AOV" && "%"}
            </Typography>

            { <Stack direction="row" spacing={1} alignItems="center">
              <Box
                sx={{
                  px: 0.75,
                  py: 0.5,
                  borderRadius: 0.5,
                  fontSize: 12,
                  fontWeight: 600,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.5,
                  border: "1px solid",
                  color: isIncreasing ? "#14CA74" : "#FF5A65",
                  borderColor: isIncreasing ? "#05C16833" : "#FF5A6533",
                  backgroundColor: isIncreasing ? "#05C16833" : "#FF5A6533",
                }}
              >
                {trendValue}%
                <Image
                  src={
                    isIncreasing
                      ? "https://sr-cdn-1.shiprocket.in/sr-promise/images/greenArrow.svg"
                      : "https://sr-cdn-1.shiprocket.in/sr-promise/images/redArrow.svg"
                  }
                  width={9}
                  height={8}
                  alt={isIncreasing ? "green Arrow" : "red Arrow"}
                  style={arrowStyle}
                />
              </Box>

              <Typography sx={{ fontSize: 12, color: "#999", lineHeight: "14px" }}>
                vs last 30 days
              </Typography>
            </Stack>}
          </Stack>

          {/* Right side chart image */}
          <Box sx={{ pr: 0.5 }}>
            <Image
              src={
                isIncreasing
                  ? "https://sr-cdn-1.shiprocket.in/sr-promise/images/increaseLine.svg"
                  : "https://sr-cdn-1.shiprocket.in/sr-promise/images/decreaseLine.svg"
              }
              width={104}
              height={70}
              alt={isIncreasing ? "increaseLine" : "decreaseLine"}
            />
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default StatBoard;
